export const getAuthQuery = (token) => ({
  jsonrpc: '2.0',
  method: 'authenticate',
  params: {
    token,
  },
})

export const getSendMessageQuery = (message, patientId, sendDate) => ({
  jsonrpc: '2.0',
  method: 'chat',
  params: {
    patient: patientId,
    message,
    sendDate: sendDate
  },
})

export const getMessagesQuery = (patient) => ({
  jsonrpc: '2.0',
  method: 'loadMessages',
  params: {
    patient,
  },
})

export const getIsReadFromQuery = (messageId, patientId) => ({
  jsonrpc: '2.0',
  method: 'isReadFrom',
  params: {
    message: messageId,
    patient: patientId
  },
})

export const getIsReadQuery = (messageId) => ({
  jsonrpc: '2.0',
  method: 'isRead',
  params: {
    message: messageId,
  },
})
